import { EMPTY_SELECT_OPTION } from 'Constants/form'

import { LostStolenReplacementFormSchema } from './LostOrStolenModal.types'

export const lostStolenReplacementFormDefaultValues: LostStolenReplacementFormSchema =
  {
    depot: EMPTY_SELECT_OPTION,
    nextDeviceId: EMPTY_SELECT_OPTION,
    previousDevice: '',
  }
